var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLinkTreeIcon = function SvgLinkTreeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16,
    r: 16,
    fill: "#FAFAFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m17.85 11.218 3.115-3.202 1.808 1.852-3.267 3.115h4.596v2.57h-4.617l3.288 3.195-1.808 1.815-4.465-4.487-4.464 4.487-1.809-1.808 3.29-3.195H8.897v-2.577h4.596l-3.267-3.115 1.808-1.852 3.114 3.202V6.666h2.702v4.552Zm-2.7 8.016h2.7v6.099h-2.7v-6.1Z",
    fill: "#222"
  })));
};

export default SvgLinkTreeIcon;